import React, { useCallback } from 'react'
import { Filter } from 'components/Filter'
import { useHomeStore } from 'context/HomeStore'
import StandardTable from 'asterX-UI/Table/StandardTable'
import { Box, Checkbox, FormControl, Grid, InputLabel } from '@material-ui/core'
import { Pagination } from 'asterX-UI/Pagination'
import { useRoutes } from 'lib/hooks'
import { CONTRACT_PATH } from 'routes/constants.routes'
import { InfoCard } from 'components/InfoCard/InfoCard'
import { SUCCESS_COLORS } from 'asterX-UI'
import { useAuthStore } from 'context/AuthStore'
import { getDaysLabel, getFomattedDateWithTime } from 'lib/utils'
import { getStatusColor, getStatusLabel } from 'lib/constants/deals'
import { AsterChip } from 'asterX-UI/Chip'
import { ChevronRight } from '@material-ui/icons'
import { UpdateList } from 'components/UpdateList'
import ContractCard from 'components/ContractCard/ContractCard'
import { MainTabs } from '../../MainTabs'
import { useStyles } from './task.styles'

const Tasks = () => {
  const routes = useRoutes()
  const classes = useStyles()
  const { authStore, authStoreFunc } = useAuthStore()
  const { homeStore, homeStoreFunc } = useHomeStore()
  const isAdmin = authStoreFunc.isAdmin()

  const handleOpenContract = useCallback(
    row => {
      const rowData = row.find(item => item?.isButton)
      const current = homeStore.contractList.find(e => e?.id === rowData?.data?.id)
      if (current) {
        routes.goTo(`${CONTRACT_PATH}/${current.id}`)
      }
    },
    [homeStore.contractList, routes]
  )

  const handleOpenBtnContract = useCallback(
    row => {
      const { id } = row
      const current = homeStore.contractList.find(e => e?.id === id)
      if (current) {
        routes.goTo(`${CONTRACT_PATH}/${current.id}`)
      }
    },
    [homeStore.contractList, routes]
  )

  const tasksColumns = () => {
    return [
      isAdmin ? (
        <Grid item key="select-all">
          <FormControl className={classes.checkbox}>
            <Checkbox
              name={'selectAll'}
              onChange={homeStoreFunc?.handleSelectAllChange}
              checked={homeStore?.selectAll}
              id={'selectAll'}
              color={'primary'}
            />
            <InputLabel shrink htmlFor={'selectAll'} className={classes.checkboxLabel}>
              №
            </InputLabel>
          </FormControl>
        </Grid>
      ) : (
        '№'
      ),
      'Клиент',
      'LEVEL',
      'Менеджер',
      'Филиал shinhan',
      'Продукт',
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc?.handleSort('loanAmount')}>
        Сумма займа {homeStoreFunc?.getArrow('loanAmount')}
      </Box>,
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc?.handleSort('overdueTranchesSum')}>
        Сумма просрочки {homeStoreFunc?.getArrow('overdueTranchesSum')}
      </Box>,
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc?.handleSort('overdueDays')}>
        Дни просрочки {homeStoreFunc?.getArrow('overdueDays')}
      </Box>,
      'Статус',
      'Последнее действие',
      'У менеджера',
      ''
    ]
  }

  const tasksRows = () => {
    if (!homeStore?.contractList) return []

    return homeStore?.contractList.map(item => {
      const isSelected = homeStore.selectedRows.includes(item?.id)

      return [
        isAdmin ? (
          <Grid item key={item?.id}>
            <FormControl className={classes.checkbox}>
              <Checkbox
                name={`contractNumber-${item?.id}`}
                onChange={() => homeStoreFunc?.handleRowCheckboxChange(item?.id)}
                checked={isSelected}
                id={`contractNumber-${item?.id}`}
                color="primary"
              />
              <InputLabel shrink htmlFor={`contractNumber-${item?.id}`} className={classes.checkboxLabel}>
                {item?.contractNumber}
              </InputLabel>
            </FormControl>
          </Grid>
        ) : (
          <Grid item>{item?.contractNumber}</Grid>
        ),
        item?.clientFullName?.replace('null', '').trim() || '-',
        <Grid style={{display:'flex', justifyContent:'center', alignItems:'center'}}>{item?.level || '-'}</Grid>,
        item?.assignToFullName,
        item?.subdivisionName,
        item?.creditProductName,
        item?.loanAmount?.toString()?.thousandSeparator(),
        item?.overdueTranchesSum?.toString()?.thousandSeparator(),
        <Grid item>{`${item?.overdueDays || 0} ${getDaysLabel(item?.overdueDays)}`}</Grid>,
        <AsterChip
          label={item?.statusName || getStatusLabel(item?.workListStatusCode) || 'Новый'}
          style={{ ...getStatusColor(item?.statusCode || item?.workListStatusCode || 'Новый'), maxWidth: 100 }}
        />,
        <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} item>
          {item?.lastManagerEventAt ? getFomattedDateWithTime(item?.lastManagerEventAt) : '-'}
        </Grid>,
        <Grid item>{`${item?.lastAssignChangeDays} ${getDaysLabel(item?.lastAssignChangeDays)}`}</Grid>,
        {
          isButton: true,
          label: <ChevronRight />,
          data: { id: item?.id }
        }
      ]
    })
  }

  const tableData = {
    columns: tasksColumns(),
    rows: tasksRows()
  }

  const renderCardView = () => {
    return (
      <Box display="flex" flexDirection="column" style={{ gap: 16, marginBottom: 10 }}>
        {homeStore?.contractList?.length > 0 && authStoreFunc.isAdmin() && (
          <Box className={classes.selectAll} onClick={homeStoreFunc?.handleSelectAllChange}>
            Выбрать все
          </Box>
        )}
        {homeStore?.contractList?.map(item => (
          <ContractCard key={item?.id} item={item} page="tasks" />
        ))}
      </Box>
    )
  }

  return (
    <>
      <MainTabs>
        <>
          <Grid item xs={12} lg={4} xl={3} style={{ marginBottom: 16 }}>
            <InfoCard
              label="Контракты в работе"
              value={homeStore?.infoCard?.countFiltered}
              color={SUCCESS_COLORS[600]}
            />
          </Grid>
          <Filter page="tasks" />
          {authStore.isMobile ? (
            renderCardView()
          ) : (
            <StandardTable
              tableData={tableData}
              onRowClick={!isAdmin ? handleOpenContract : undefined}
              onButtonClick={isAdmin ? handleOpenBtnContract : undefined}
              btnStyle={{
                backgroundColor: 'transparent',
                border: 'none',
                padding: 8,
                minWidth: 'auto',
                cursor: 'pointer'
              }}
              tableStyles={{
                '--table-layout': 'fixed',
                '--th-white-space': 'normal',
                '--th-word-break': 'break-word'
              }}
              columnMaxWidths={{2:'45px',3:'80px',4:'200px',10:'100px'}}
              thAdaptive={true}
            />
          )}

          <Grid item xs={12}>
            <Pagination
              count={Math.ceil(homeStore?.pagination?.count / 30)}
              page={homeStore?.pagination?.offset + 1}
              onChange={homeStoreFunc.handlePaginationChange}
              isMobile={authStore.isMobile}
            />
          </Grid>
        </>
      </MainTabs>
      <UpdateList page="tasks" />
    </>
  )
}

export default React.memo(Tasks)
